export default "__VITE_ASSET__B82bWYGo__"